import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

class ChatService {
  static async sendMessage({ document_ids, content, use_turbo = false }) {
    try {
      const response = await axios.post(`${API_URL}/chat/message`, {
        document_ids,
        content,
        use_turbo
      });
      console.log('Chat response:', response.data); // Debug log
      if (response.data.visualization) {
        console.log('Visualization data:', response.data.visualization);
      }
      return response.data;
    } catch (error) {
      console.error('Error in ChatService:', error);
      throw error;
    }
  }

  static async getChatHistory(document_ids, use_turbo) {
    try {
      const params = new URLSearchParams();
      document_ids.forEach(id => params.append('document_ids[]', id));
      params.append('use_turbo', Boolean(use_turbo).toString());
      
      const response = await axios.get(`${API_URL}/chat/history`, { params });
      
      // Transform messages to include visualization and table_data
      const messages = (response.data.messages || []).map(msg => ({
        ...msg,
        table_data: msg.table_data || null,
        visualization: msg.visualization || null,
        timestamp: msg.timestamp || new Date().toISOString()
      }));
      
      console.log('Processed chat history:', messages); // Debug log
      
      return {
        messages: messages,
        error: null
      };
    } catch (error) {
      console.error('Error fetching chat history:', error);
      throw new Error(error.response?.data?.detail || 'Failed to load chat history');
    }
  }
}

export default ChatService;